module.exports = __webpack_public_path__ + "img/1_4.26ea2c36.jpg";